import React from 'react';
import { Drawer } from '@mui/material';
import BasicLabel from '../../labels/components/BasicLabel';
import { useTranslation } from 'react-i18next';
import AccurityButton from '../../buttons/components/AccurityButton';
var NotificationCenter = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, dismissAll = _a.dismissAll, isDismissAllVisible = _a.isDismissAllVisible, children = _a.children;
    var notificationCount = React.Children.count(children);
    var t = useTranslation().t;
    return (React.createElement(Drawer, { className: 'notificationCenter', anchor: 'right', open: isOpen, onClose: onClose, ModalProps: {
            container: document.getElementById('appContainer')
        } },
        children,
        isDismissAllVisible && (React.createElement("div", { className: 'notificationCenter__dismissAllButton' },
            React.createElement(AccurityButton, { "aria-label": "dismissAll", onClick: dismissAll, variant: "outlined", fullWidth: true }, t('notificationCenter.dismissAll')))),
        notificationCount === 0 && React.createElement(BasicLabel, { className: 'notificationCenter__label', value: t('notificationCenter.noNewNotifications') })));
};
export default NotificationCenter;
//# sourceMappingURL=NotificationCenter.js.map